'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('../styles');

var _styles2 = _interopRequireDefault(_styles);

var _Dialog = require('@material-ui/core/Dialog');

var _Dialog2 = _interopRequireDefault(_Dialog);

var _lib = require('@eui/ds-icons/lib');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _EDSContext = require('../EDSContext/EDSContext');

var _useEnforceFocusFlag3 = require('./internal/useEnforceFocusFlag');

var _useEnforceFocusFlag4 = _interopRequireDefault(_useEnforceFocusFlag3);

var _tokens = require('../styles/tokens');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
    var _paper, _internalDialog;

    return {

        // Styles applied to the root element.
        root: {
            '&.fullScreen': {
                padding: 0,
                '& .dialog-close-button': {
                    top: _tokens.spacingXSmall,
                    right: _tokens.spacingXSmall
                }
            }
        },

        // Styles applied to the Paper component.
        paper: (_paper = {
            borderRadius: _tokens.borderRadiusMedium,
            minHeight: '12.5rem',
            padding: _tokens.spacingSmall,
            width: '21rem'
        }, _defineProperty(_paper, '@media ' + _tokens.mqSmall, {
            padding: _tokens.spacingLarge,
            width: '37.5rem'
        }), _defineProperty(_paper, '@media ' + _tokens.mqMedium, {
            padding: _tokens.spacingLarge,
            width: '39.625rem'
        }), _defineProperty(_paper, '@media ' + _tokens.mqLarge, {
            padding: _tokens.spacingLarge,
            width: '53rem'
        }), _paper),

        // Styles applied to the Paper component if fullWidth=true.
        paperFullWidth: {
            width: _tokens.widthFluid + ' !important'
        },

        dialogXButton: {
            background: 'none',
            border: 'none',
            width: _tokens.sizingXxLarge,
            height: _tokens.sizingXxLarge,
            position: 'absolute',
            top: _tokens.spacingSmall,
            right: _tokens.spacingSmall,
            textAlign: 'center',
            '&:active': {
                color: theme.palette.ctaColor.active
            },
            '&:hover': {
                color: theme.palette.ctaColor.hover
            },
            '&:active:hover': {
                color: theme.palette.ctaColor.active
            }
        },
        paperFullScreen: {
            // TODO: Find a better way to increase the opacity.
            // internalDialog classes are overriding this class for now,
            // hence !important.
            width: _tokens.widthFluid + ' !important',
            borderRadius: _tokens.borderRadiusReset + ' !important'
        },

        internalDialog: (_internalDialog = {
            padding: '1.25rem',
            borderRadius: _tokens.sizingXSmall,
            position: 'relative',
            minHeight: '12.5rem',
            width: '21.5rem'
        }, _defineProperty(_internalDialog, '@media ' + _tokens.mqSmall, {
            width: '37.5rem'
        }), _defineProperty(_internalDialog, '@media ' + _tokens.mqMedium, {
            width: '39.625rem'
        }), _defineProperty(_internalDialog, '@media ' + _tokens.mqLarge, {
            width: '53rem'
        }), _internalDialog)
    };
};

var paperClassName = 'eds-dialog-paper';

/**
 * Use `Dialog` to display information without losing the context of the page.
 * @done true
 * @updated false
 * @versionAdded v0.0.10
 * @examples
 *  DialogA11y
 */
var Dialog = _react2.default.forwardRef(function (props, ref) {
    var _useEnforceFocusFlag = (0, _useEnforceFocusFlag4.default)(),
        _useEnforceFocusFlag2 = _slicedToArray(_useEnforceFocusFlag, 3),
        disableEnforceFocusFlag = _useEnforceFocusFlag2[0],
        onFocus = _useEnforceFocusFlag2[1],
        onBlur = _useEnforceFocusFlag2[2];

    var children = props.children,
        classesProp = props.classes,
        onClose = props.onClose,
        showTitleBarClose = props.showTitleBarClose,
        PaperPropsProp = props.PaperProps,
        edsContext = props.edsContext,
        open = props.open,
        fullScreen = props.fullScreen,
        rest = _objectWithoutProperties(props, ['children', 'classes', 'onClose', 'showTitleBarClose', 'PaperProps', 'edsContext', 'open', 'fullScreen']);

    var classes = {
        root: classesProp.root,
        paper: classesProp.paper,
        paperWidthXs: classesProp.paperWidthXs,
        paperWidthSm: classesProp.paperWidthSm,
        paperWidthMd: classesProp.paperWidthMd,
        paperFullWidth: classesProp.paperFullWidth,
        paperFullScreen: classesProp.paperFullScreen
    };

    // local overrides to the dialog's internal paper
    var internalPaperProps = {
        classes: {
            root: classesProp.internalDialog
        },
        className: paperClassName
    };

    // incorporate consumer's paper overrides as well (if any)
    var PaperProps2 = Object.assign(internalPaperProps, PaperPropsProp);

    // style the close 'x' in the title
    var buttonClasses = (0, _classnames2.default)(undefined !== props.className ? props.className : '', 'dialog-close-button', classesProp.dialogXButton);

    var onFocusCallback = function onFocusCallback(e) {
        var propsOnFocus = props.onFocus;

        onFocus(e);
        propsOnFocus && propsOnFocus(e);
    };

    var onBlurCallback = function onBlurCallback(e) {
        var propsOnBlur = props.onFocus;

        onBlur(e);
        propsOnBlur && propsOnBlur(e);
    };

    return _react2.default.createElement(
        _Dialog2.default,
        Object.assign({
            classes: classes,
            disableBackdropClick: true,
            disableEscapeKeyDown: true,
            PaperProps: PaperProps2,
            onClose: onClose,
            className: 'eds-dialog',
            open: open,
            fullScreen: fullScreen,
            onFocus: onFocusCallback,
            onBlur: onBlurCallback
        }, rest, {
            ref: ref,
            disableEnforceFocus: disableEnforceFocusFlag
        }),
        showTitleBarClose && _react2.default.createElement(
            'button',
            {
                'aria-label': edsContext.formatMessage('component.Dialog.close'),
                title: edsContext.formatMessage('component.Dialog.close'),
                className: buttonClasses,
                onClick: onClose },
            _react2.default.createElement(_lib.Icon, { name: 'close', large: true })
        ),
        children
    );
});

Dialog.muiName = 'Dialog';
Dialog.displayName = 'Dialog';

Dialog.propTypes = {
    /**
     * @ignore
     */
    BackdropProps: _propTypes2.default.object,
    /**
     * Dialog children, usually the included sub-components.
     */
    children: _propTypes2.default.node.isRequired,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: _propTypes2.default.object.isRequired,
    /**
     * @ignore
     */
    className: _propTypes2.default.string,
    /**
     * If `true`, clicking the backdrop will not fire the `onClose` callback.
     */
    disableBackdropClick: _propTypes2.default.bool,
    /**
     * If `true`, hitting escape will not fire the `onClose` callback.
     */
    disableEscapeKeyDown: _propTypes2.default.bool,
    /**
     * If `true`, the dialog will be full-screen
     */
    fullScreen: _propTypes2.default.bool,
    /**
     * If `true`, the dialog stretches to `maxWidth`.
     */
    fullWidth: _propTypes2.default.bool,
    /**
     * @ignore
     */
    edsContext: _propTypes2.default.object,
    /**
     * Determine the max width of the dialog.
     *
     * The dialog width grows with the size of the screen, this property is useful
     * on the desktop where you might need some different widths across your
     * application.
     *
     * Valid values:
     *
     * * `xs`
     * * `sm`
     * * `md`
     * * `lg`
     * * `false` (disables max width)
     */
    maxWidth: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', false]),
    /**
     * Callback fired when the backdrop is clicked.
     */
    onBackdropClick: _propTypes2.default.func,
    /**
     * Callback fired when the component requests to be closed.
     *
     * @param {object} event The event source of the callback
     */
    onClose: _propTypes2.default.func,
    /**
     * Callback fired before the dialog enters.
     */
    onEnter: _propTypes2.default.func,
    /**
     * Callback fired when the dialog has entered.
     */
    onEntered: _propTypes2.default.func,
    /**
     * Callback fired when the dialog is entering.
     */
    onEntering: _propTypes2.default.func,
    /**
     * Callback fired when the escape key is pressed,
     * `disableKeyboard` is false and the modal is in focus.
     */
    onEscapeKeyDown: _propTypes2.default.func,
    /**
     * Callback fired before the dialog exits.
     */
    onExit: _propTypes2.default.func,
    /**
     * Callback fired when the dialog has exited.
     */
    onExited: _propTypes2.default.func,
    /**
     * Callback fired when the dialog is exiting.
     */
    onExiting: _propTypes2.default.func,
    /**
     * If `true`, the Dialog is open.
     */
    open: _propTypes2.default.bool.isRequired,
    /**
     * Properties applied to the dialog's internal Paper element.
     */
    PaperProps: _propTypes2.default.object,
    /**
     * Determine the container for scrolling the dialog.
     */
    scroll: _propTypes2.default.oneOf(['body', 'paper']),
    /**
     * Whether to show a close 'x' in the title bar. Clicking this invokes the
     * `onClose` handler.
     */
    showTitleBarClose: _propTypes2.default.bool,
    /**
     * Transition component.
     */
    TransitionComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.object]),
    /**
     * The duration for the transition, in milliseconds.
     * You may specify a single timeout for all transitions, or individually with an object.
     */
    transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })]),
    /**
     * Properties applied to the `Transition` element.
     */
    TransitionProps: _propTypes2.default.object
};

Dialog.defaultProps = {
    disableBackdropClick: false,
    disableEscapeKeyDown: false,
    fullScreen: false,
    fullWidth: false,
    maxWidth: 'sm',
    scroll: 'paper',
    showTitleBarClose: true
};

exports.default = (0, _EDSContext.withEDSContext)((0, _styles2.default)(styles)(Dialog));